import React from "react";

const { Provider, Consumer } = React.createContext();

export { Provider as BackdropProvider };
export { Consumer as BackdropConsumer };



// WEBPACK FOOTER //
// ./src/components/List/BackdropContext.js